import { Button, CloseIcon, Modal, PropsWithBox } from "@saleor/macaw-ui-next";
import React from "react";

type CloseProps = PropsWithBox<{
  /** Radix already reports the close through the root's onChange; pass this
   *  only when something else has to happen on click. */
  onClose?: () => void;
  /** Accessible name for the icon-only button. */
  "aria-label"?: string;
  "data-test-id"?: string;
}>;

export const Close = ({
  onClose,
  "aria-label": ariaLabel,
  "data-test-id": testId,
  ...rest
}: CloseProps) => {
  return (
    <Modal.Close {...rest}>
      <Button
        icon={<CloseIcon />}
        size="small"
        variant="tertiary"
        onClick={onClose}
        aria-label={ariaLabel}
        data-test-id={testId}
      />
    </Modal.Close>
  );
};
